import {Pipe, PipeTransform} from '@angular/core';
import {convertPrice} from '../utils/convert-price.util';

@Pipe({
	name: 'tvcorePrice',
	standalone: false
})
export class PricePipe implements PipeTransform {
	transform(price: string | number, decimal: boolean = false): string {
		let value: number | null = convertPrice(price);

		if (isNaN(value || 0)) {
			value = null;
		}

		if (value || value === 0) {
			const n = Math.floor(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');

			if (decimal) {
				const c = value.toFixed(2).split('.')[1];
				return `${n}.${c}`;
			}

			return n;
		}

		return decimal ? '0.00' : '0';
	}
}
